import { InvoiceTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1961. 請求タスクコメントリアクションtoggle
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  emoji_id: string;
  content: string;
};

const invoiceTaskCommentReaction = (props: Props): Promise<InvoiceTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_comments/${props.id}/reactions`,
    props
  );
};

export const useInvoiceTaskCommentReaction = () => {
  return useMutation({
    mutationFn: invoiceTaskCommentReaction,
  });
};
